export enum ClientEvents {
    INITIATE_CHECKOUT = 'initiateCheckout',
    PAYMENT_FINISHED = 'paymentFinished',
    FIRST_BUY = 'firstBuy',
    TUTORIAL_100_CLICKS = 'tutorial100Clicks',
    N_DAY_RETENTION = 'nDayRetention',
    FIRST_DAY_RETENTION = 'firstDayRetention',
    NOT_INSTALL = 'notInstall',
    REBILL_BUY = 'rebillBuy',
    SUCCESS_BUY = 'successBuy',
    SERVER_LOGIN = 'serverLogin',
    FEEDBACK_SEND = 'feedbackSend',
    PREREG_LANDING = 'landing',
    PREREG_CONFIRM = 'preregConfirm',
    PREREG_COMPLETE = 'preregComplete',
    CITY_LEVEL_UP = 'levelUp',
    INSTALL = 'install',
    SWITCH_TO_WEBGL = 'switchToWebgl',
    WEBGL_START_LOADING = 'webglStartLoading',
    WEBGL_FINISH_LOADING = 'webglFinishLoading',
    FAIL_INDEXED_DB = 'failIndexedDb',
    SHOW_PRELOADER = 'showPreloader',
    HIDE_PRELOADER = 'hidePreloader',
    FIRST_CLICK = 'firstClick',
    HERO_LEVEL_UP = 'heroLevelUp',
    MARCHES_9 = 'marches9',
    VALOR_MONSTER_1000 = 'valorMonster1000',
    VALOR_MONSTER_1000_PER_MARCH = 'valorMonster1000PerMarch',
    UNITS_TRAIN_SILVER_10000 = 'unitsTrainSilver10000',
    MONSTER_LVL_5 = 'monsterLvl5',
    PAYMENT_METHOD_CHOSEN = 'paymentMethodChosen',
    PAYMENT_PROCEED = 'paymentProceed',
}

